import AddAllDocsToDataRoomModal from './AddAllDocsToDataRoomModal.component';

export default AddAllDocsToDataRoomModal;